import { SCOPE_TYPE } from "@model";

export function hasVfaPattern24_2C(scopeList: string[] | null | undefined): boolean {
  return Boolean(scopeList?.includes(SCOPE_TYPE.vfaPattern24_2C));
}
